const typography = {
  weight: {
    light: 300,
    regular: 400,
    semiBold: 600,
    /**
     * @deprecated Use `semiBold` value instead
     */
    extraBold: 600
  },
  lineHeight: {
    body: "1.5",
    header: "1.25"
  },
  size: {
    mini: "10px",
    uno: "12px",
    hecto: "14px",
    kilo: "16px",
    giga: "20px",
    tera: "24px",
    zetta: "32px",
    bronto: "46px"
  }
};

export default typography;
